// extracted by mini-css-extract-plugin
module.exports = {"avatarBox":"avatar_avatarBox_c21H6","imageBox":"avatar_imageBox_2bXbY","label":"avatar_label_3sikN"};